import { ValidateWebQuoteCommandTypes } from "../_common/machines/ecommerce-machine/data-loading/validate-web-quote-command-machine"

export const webQuoteServerValidationError = (state: ValidateWebQuoteCommandTypes["State"]) => {
    if (state.matches("error") && state.context.error?.type == "ERROR") {
        return state.context.error.error.errorCode
    }
    return undefined
}
